module.exports = __webpack_public_path__ + "img/dark-event.e25eddfb.svg";